import { api } from 'API';
import { addImposterToUrl } from 'Utils';

const baseUrl = '/newRequest/categories';
const recentRequestsUrl = '/newRequest/last-newReq-categories';
const popularCategoriesUrl = '/newRequest/popular-categories';

export interface IRequestCategories {
  subjects: ISubject[];
  departments: IDepartment[];
  subSubjects: ISubCategory[];
}

export interface ISubject {
  id: number;
  title: string;
  subSubjectIds: number[];
}

export interface IDepartment {
  id: number;
  title: string;
  parentCatagories: ISubject[];
}

export interface ISubCategory {
  title: string;
  id: number;
  parentTitle: string;
  link?: string;
  description?: string;
  descriptionLink?: string;
  onlineFormLink?: string;
  onlineFormLinkPrefixText?: string;
  onlineFormLinkText?: string;
  attachmentId?: number;
  disabilityName?: string;
  isOnlineFormLinkForDownload?: boolean;
  onlineFormAlertText?: string;
  onlineFormLinkSuffixText?: string;
  isOpenLinkInNewTab?: boolean;
}

export interface IRecentRequests {
  id: number;
  title: string;
}

const DEFAULT_RECENT_REQUESTS_LIMIT = 3;

export const getRequestCategories = async (): Promise<
  IRequestCategories | undefined
> => {
  const res = await api.get<IRequestCategories>(
    addImposterToUrl(baseUrl, true)
  );
  if (res.data) return res.data;
};

export const getRecentRequests = async (
  limit = DEFAULT_RECENT_REQUESTS_LIMIT
) => {
  const res = await api.get<IRecentRequests[]>(
    addImposterToUrl(`${recentRequestsUrl}?lastCatsAmount=${limit}`)
  );

  if (res.data) return res.data;
};

export const getPopularCategories = async () => {
  const res = await api.get<IRecentRequests[]>(popularCategoriesUrl);
  if (res.data) return res.data;
};
